import { P2GBox, P2GProgress } from '@parcel2go/core-ui';

export const FullScreenLoading = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      position: 'fixed',
      width: '100%'
    }}
  >
    <P2GProgress />
  </div>
);

export default function Loading() {
  return (
    <P2GBox textAlign="center">
      <P2GProgress />
    </P2GBox>
  );
}
